import React from "react";
import { Navigate, Outlet } from "react-router";

import authService from "services/auth";

const RestrictedRoute = () => {
  const accessToken = authService().getAccessToken();
  const refreshToken = authService().getRefreshToken();

  const isAuthenticated = !!accessToken && !!refreshToken;

  return isAuthenticated ? <Navigate replace to="/home" /> : <Outlet />;
};

export default RestrictedRoute;
